const languageLocales = {
    italian: 'it-IT',
    english: 'en-US',
    spanish: 'es-ES',
    french: 'fr-FR',
    portuguese: 'pt-PT',
};

export function speakText(text, onEnd, targetLanguage) {
    if (!text || !('speechSynthesis' in window)) return;

    const cleanText = text
        .replace(/[\u{1F300}-\u{1FAFF}\u{1F000}-\u{1F02F}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{200D}\u{2B00}-\u{2BFF}]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();

    if (!cleanText) return;

    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(cleanText);
    const locale = languageLocales[(targetLanguage || 'italian').toLowerCase()] || 'it-IT';
    utterance.lang = locale;
    utterance.rate = 0.85;
    if (onEnd) utterance.onend = onEnd;
    window.speechSynthesis.speak(utterance);
}

// Despite the name, this speaks in whichever language the learner has selected.
// The name stays so existing screens keep working.
export function speakItalian(text, onEnd) {
    const language = localStorage.getItem('vozoly_target_language') || 'italian';
    speakText(text, onEnd, language);
}

export function stopSpeaking() {
    if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
    }
}